<p-galleria
  #galleria
  [value]="movieImages"
  [(activeIndex)]="activeIndex"
  [numVisible]="4"
  [containerStyle]="{ 'max-width': '640px' }"
  [containerClass]="galleriaClass()"
  [showThumbnails]="showThumbnails"
  [showItemNavigators]="true"
  [showItemNavigatorsOnHover]="true"
  [circular]="true"
  [transitionInterval]="0"
>
  <ng-template pTemplate="item" let-item>
    <!-- ternary tree to handle correct image size display in this component -->
    <img
      [alt]="item?.title + ' gallery image'"
      class="galleria-main-image"
      [src]="item.imageUrl | img"
      [sizes]="fullscreen ? '100vw' : '(max-width: 993px) 75vw, 40vw'"
      [srcset]="getGallerySrcSets(item.imageUrl)"
      [style.aspect-ratio]="aspectRatio || null"
      style="width: 100%; display: block"
      [modal]="{ src: item.imageUrl, type: 'landscape', imgType: 'tile-img' }"
    />
  </ng-template>
  <ng-template pTemplate="thumbnail" let-item>
    <div class="p-grid p-nogutter p-justify-center">
      <img
        [alt]="item?.title + ' thumbnail image'"
        [ngClass]="{ 'thumbnail-fullscreen': fullscreen, 'thumbnail-mobile': !fullscreen }"
        [src]="
          !fullscreen
            ? (item.imageUrl | img: { width: 200 })
            : screenWidth > 600
              ? (item.imageUrl | img: { width: 300 })
              : (item.imageUrl | img: { width: 200 })
        "
        [modal]="{ src: item.imageUrl, type: 'landscape', imgType: 'tile-img' }"
      />
    </div>
  </ng-template>
  <ng-template pTemplate="footer" let-item>
    <div class="custom-galleria-footer">
      <button type="button" pButton icon="pi pi-list" (click)="onThumbnailButtonClick()"></button>
      <span *ngIf="movieImages" class="title-container">
        <span>{{ activeIndex + 1 }}/{{ movieImages.length }}</span>
        <span class="title">{{ movieImages[activeIndex].title }}</span>
      </span>
      <p-button
        type="button"
        [icon]="fullScreenIcon()"
        (onClick)="toggleFullScreen()"
        class="fullscreen-button"
      ></p-button>
    </div>
  </ng-template>
</p-galleria>
